import { createApi } from "@reduxjs/toolkit/query/react";
import {
  baseQueryDocument,
  baseQueryHr,
  baseQueryNlpc,
  baseQueryVendor,
} from "./baseQuery";
import { API } from "./constant";
import { toast } from "react-toastify";
import { VendorServices } from "../../utils/redux/Vendor/VendorService";

export const documentApi = createApi({
  baseQuery: baseQueryDocument,
  reducerPath: "documentApi",

  endpoints: (builder) => ({
    documentPost: builder.mutation({
      query: (req) => ({
        url: req.path,
        method: "POST",
        body: req.datas,
      }),
      transformErrorResponse: (err) => {
        if (err.status === "FETCH_ERROR") {
          toast.error("Network Error");
        }

        if (err.status === 404 && !err?.data?.statusMessage) {
          toast.error("invalid API", "error");
        } else if (err.status === 500) {
          toast.error(
            "Something went wrong. It’s not you, it’s us. Please give it another try.",
            "error"
          );
        } else if (err.status === 401) {
          toast.error("session has expired login, please login to continue ");
          localStorage.removeItem("token");
          window.location.replace("/");
        }
        return err;
      },
    }),
    documentGet: builder.query({
      query: (queries) => queries,
      transformErrorResponse: (err) => {
        if (err.status === "FETCH_ERROR") {
          toast.error("Network Error");
        } else if (err.status === 500) {
          toast.error(
            "Something went wrong. It’s not you, it’s us. Please give it another try."
          );
        } else if (err.status === 401) {
          toast.error("session has expired login, please login to continue ");
          localStorage.removeItem("token");
          window.location.replace("/");
        }
        return err;
      },
    }),
  }),
});

export const { useDocumentGetQuery, useDocumentPostMutation } = documentApi;
